import { render, staticRenderFns } from "./MediaAppearanceItem.vue?vue&type=template&id=22459ebe&scoped=true&"
import script from "./MediaAppearanceItem.vue?vue&type=script&lang=ts&"
export * from "./MediaAppearanceItem.vue?vue&type=script&lang=ts&"
import style0 from "./MediaAppearanceItem.vue?vue&type=style&index=0&id=22459ebe&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "22459ebe",
  null
  
)

export default component.exports